import { render, staticRenderFns } from "./MerchantApp.vue?vue&type=template&id=bfc0b090&scoped=true&lang=pug&"
import script from "./MerchantApp.vue?vue&type=script&lang=js&"
export * from "./MerchantApp.vue?vue&type=script&lang=js&"
import style0 from "./MerchantApp.vue?vue&type=style&index=0&id=bfc0b090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc0b090",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBottomNavigation,VBtn,VIcon,VSkeletonLoader})
